import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

type GetCarvagoBuyDisabledTooltipLabelParams = {
  isBlocked: boolean;
  isAlreadyRequested: boolean;
  isInactive?: boolean;
};

export function getCarvagoBuyDisabledTooltipLabel({
  isBlocked,
  isAlreadyRequested,
  isInactive = false,
}: GetCarvagoBuyDisabledTooltipLabelParams): string | undefined {
  return match({isBlocked, isAlreadyRequested, isInactive})
    .with({isAlreadyRequested: true}, () =>
      i18n.t('entity.sourcing.notifications.alreadyRequestedOnCarvago')
    )
    .with({isInactive: true}, () => i18n.t('entity.sourcing.labels.inactiveAdvertisementTooltip'))
    .with({isBlocked: true}, () => i18n.t('entity.sourcing.notifications.cannotRequestOnCarvago'))
    .otherwise(() => undefined);
}
